import { Box } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/system";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  link: {
    font: "700 12px/19px Manrope",
    color: "#308CDB !important",
  },
  bigText: {
    font: "700 20px/28px Manrope",
    color: "#344054",
    marginBottom: "8px",
  },
  middleText: {
    font: "500 16px/24px Manrope",
    color: "#465869",
  },
  smallText: {
    font: "500 12px/19px Manrope",
    color: "#465869",
  },
  availableOptionsText: {
    font: "700 12px/19px Manrope",
    color: "#308CDB",
    whiteSpace: "nowrap",
  },
  icon: {
    fontSize: "15px !important",
    color: "#308CDB",

    "@media (max-width: 1150px)": {
      display: "none !important",
    },
  },
  gridConteinerInfoIcon: {
    marginTop: "24px",
    marginBottom: "50px",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  gridItem: {
    border: "1px solid #308CDB",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "7px 20px",
    gap: "12px",
    width: "100%",

    "& .icon": {
      "@media (max-width: 1150px)": {
        display: "none !important",
      },
    },
  },
}));

const Badge = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  padding: "0 4px",
  height: "16px",
  width: "16px",
  background: "#38CFC4",
  borderRadius: "16px",
  marginLeft: "auto",
  fontFamily: "Manrope !important",
  fontWeight: 600,
  fontSize: "10px",
  color: "#FFF",
  alignSelf: "flex-end",
});

export { Badge };
export default styles;
